import { render } from "./TheWelcome.vue?vue&type=template&id=4e31cfa2&scoped=true"
import script from "./TheWelcome.vue?vue&type=script&lang=js"
export * from "./TheWelcome.vue?vue&type=script&lang=js"

import "./TheWelcome.vue?vue&type=style&index=0&id=4e31cfa2&scoped=true&lang=css"

import exportComponent from "E:\\GIT\\WEB\\catch-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e31cfa2"]])

export default __exports__